/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SignIn/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Email from './Email/index'
import HappyToothGraphic from 'DesignSystem/Svgs/HappyToothGraphic/index'
import Info from 'DesignSystem/Info/index'
import OnboardingInfoDesktop from 'DesignSystem/OnboardingInfoDesktop/index'
import Password from './Password/index'
import React from 'react'
import Submit from './Submit/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaTextLink from 'DesignSystem/TysiaTextLink/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function SignIn({
  children,
  viewPath = "/App/Auth/SignIn"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsBrandBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.brand.base'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="SignIn.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="SignIn.Vertical"
  data-view-path={viewPath}
 style={{'--o-2-Z29l7Yn': isBefore ? 0 : 1,'--w-1-Z29l7Yn': isMedia.mobile ? "100%" : "50%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="SignIn.Vertical:1"
  data-view-path={viewPath}
 style={{'--w-1-Z29l7Yn': isMedia.mobile ? "340px" : "360px"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="SignIn.Vertical:2"
  data-view-path={viewPath}
 style={{'--mr-3-Z29l7Yn': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical2}`}
>
<HappyToothGraphic
  viewPath={`${viewPath}/HappyToothGraphic`}
 width={80}
 height={80}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Practice Hub"
/>
</div>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Sign In"
/>
<Email
  viewPath={`${viewPath}/Email`}
/>
<Password
  viewPath={`${viewPath}/Password`}
/>
<Submit
  viewPath={`${viewPath}/Submit`}
/>
<div
  data-testid="SignIn.Horizontal:1"
  data-view-path={viewPath}
 style={{'--btc-4-Z29l7Yn': dtColorsNeutral100}}
 className={`views-block ${styles.Horizontal1}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="By signing in I agree to"
 size="small"
 marginRight={dtSpaceXxs}
 marginTop={dtSpaceS}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 text="Terms of use"
 size="small"
 color={dtColorsBrandBase}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../TermsAndConditions'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../TermsAndConditions'))}
/>
</div>
<div
  data-testid="SignIn.Horizontal:2"
  data-view-path={viewPath}
 style={{'--mt-5-Z29l7Yn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal2}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="Forgot my password?"
 size="small"
 marginRight={dtSpaceXxs}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 text="Reset password"
 size="small"
 color={dtColorsBrandBase}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../ResetPassword'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../ResetPassword'))}
/>
</div>
<div
  data-testid="SignIn.Horizontal:3"
  data-view-path={viewPath}
 style={{'--mt-5-Z29l7Yn': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal3}`}
>
<Info
  viewPath={`${viewPath}/Info`}
 text="New to Practice Hub?"
 size="small"
 marginRight={dtSpaceXxs}
/>
<TysiaTextLink
  viewPath={`${viewPath}/TysiaTextLink`}
 size="small"
 text="Verify your email"
 color={dtColorsBrandBase}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../SignUp'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../SignUp'))}
/>
</div>
</div>
</div>
<fromFlow.When is={!isMedia.mobile}>
<OnboardingInfoDesktop
  viewPath={`${viewPath}/OnboardingInfoDesktop`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}